import { action, observable } from 'mobx';
import { getExchangeUrl } from '@/utils/location';
import Axios from 'axios';
import { NoticeModuleEnum } from '@/@enums/Notice';

export interface NoticeItem {
  title: string;
  content: string;
}

export default class Notice {
  @observable isShowNotice: boolean;

  @observable maintain: NoticeItem | null;

  constructor() {
    this.isShowNotice = false;
    this.maintain = null;
  }

  @action.bound
  setIsShowNotice(data: boolean) {
    this.isShowNotice = data;
  }

  @action.bound
  setMaintain(data: NoticeItem) {
    this.maintain = data;
  }

  @action.bound
  async fetchMaintainNotice(module: NoticeModuleEnum) {
    // const result: NoticeItem = await Axios.get('/public/maintain/tips', {
    //   baseURL: getExchangeUrl().xtMarket,
    //   headers: {
    //     device: 'web',
    //   },
    //   params: {
    //     module,
    //   },
    // });
    //
    // if (result) {
    //   this.setIsShowNotice(true);
    //   this.setMaintain(result);
    // }
  }
}
